<template>
    <div v-bind:class="className">
      <nav class="main-nav navbar navbar-light bg-light">
        <!-- /.navbar-brand -->
        <div class="navbar-brand">
          <!--<img src="/assets/brand/bootstrap-solid.svg" width="30" height="30" class="d-inline-block align-top" alt="">-->
          <!--Bold-->
          <logoMinimal class="animated fadeIn"></logoMinimal>
        </div>
        <div class="links mr">
          <a href="https://www.boldcomunicacao.com.br/blog" target="_blank" class="">Blog</a>
          <a href="#/contact" class="">Contato</a>
        </div>
        <!-- /.links -->
      </nav>

    </div>
</template>

<script>
  import logoMinimal from '../assets/logo-minimal.svg'
  export default {
    name: 'Menu',
    data () {
      return {}
    },
    computed:{
      className() {
        return this.$store.getters.getMenuClass;
      },
    },
    components:{
      logoMinimal
    },
    methods:{
      goToContact(){
        this.$router.push('/contact');
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue